import { api } from '.';
import {
  errorFetch,
  isFetching,
  successFetch,
} from '../../store/actions/app.action';

/**
 * Creates the request route and gets data for request
 *
 * @param {String} cmd Raw route for request
 * @param {Array|Object} params Data for request
 */
const createRequest = (cmd, params) => {
  const paramRegex = /\{\w+\}/g;
  const type = cmd.split(':')[0];
  let route = cmd.split(':')[1];
  let data = params;

  // There are parameters that need to go in to the route.
  if (route.match(paramRegex)) {
    // There are route parameters only.
    if (params.constructor === Array) {
      route = route.replace(paramRegex, () => params.shift());
      data = null;

      // There are route parameters and request data parameters.
    } else {
      const newParams = params.parameters;

      route = route.replace(paramRegex, () => newParams.shift());
      data = params.data;
    }
  }

  return { data: data, route, type };
};

/**
 * Makes an API call to the back-end
 *
 * @param {{}} action Redux action
 * @returns {*} Data response from back-end
 *
 * @fires api.get
 * @fires api.post
 */
export const makeCall = async (action) => {
  const request = createRequest(action.cmd, action.payload);
  let res;
  let resPromise;

  try {
    if (request.type === 'GET') {
      resPromise = api.get(request.route);
    } else if (request.type === 'POST') {
      resPromise = api.post(request.route, request.data);
    } else if (request.type === 'PUT') {
      resPromise = api.put(request.route, request.data);
    } else if (request.type === 'DELETE') {
      resPromise = api.delete(request.route);
    } else {
      throw Error('ERROR: Invalid request type');
    }
  } catch {
    alert('Need an error handling system!!');
  }

  try {
    res = await resPromise;
    // console.log('res: ', res);
  } catch (err) {
    throw { data: err.response.data, status: err.response.status };
  }

  return res;
};

/**
 * Creates a local action.
 *  - Only for use for apiCaller
 *
 * @param {*} payload Data to be passed to reducer
 * @param {{}} action Remote action intercepted
 */
const createAction = (payload, action) => ({
  cmd: action.cmd,
  type: action.type,
  payload,
});

const appFetching = async (action, next, dispatch) => {
  const { status } = action;
  let statusAction;

  // Create loading action.
  if (status) {
    dispatch(isFetching(status));
  }

  // Make API call
  try {
    const { data } = await makeCall(action);

    dispatch(createAction(data, action));

    statusAction = successFetch(status);
  } catch (error) {
    console.log('error: ', error);

    dispatch(createAction(error, action));

    statusAction = errorFetch(status, error.data.msg);
  }

  dispatch(statusAction);
};

/**
 * Redux middleware that will intercept any "remote" 'actions' and make an API
 * call to the back-end and return the result to the appropriate 'reducer'
 *
 * @fires makeCall
 * @fires next : Next middleware in line-up
 * @fires store.dispatch
 * @public
 */
export const apiMiddleware = ({ dispatch }) => (next) => (action) => {
  if (action.remote) {
    appFetching(action, next, dispatch);
  } else {
    next(action);
  }
};
